import { useEffect, useState, useRef } from "react";
import {
  Container,
  Body,
  Content,
  ContentHeader,
} from "../components/Container.Style";
import {
  Table,
  TableHeader,
  TableBody,
  Td,
  Tr,
} from "../components/Table.Style";
import Button from "../components/Input/Button";
import Header from "../components/Header/Header";
import Sidebar from "../components/Sidebar/Sidebar";
import Search from "../components/Input/Search";

import ExportIcon from "../assets/images/export.svg";

import attendeeServices from "../services/attendee.services";

function Users() {
  const conferenceId = useRef("6450ef126edf8bb73cd14c78");
  const [search, setSearch] = useState("");
  const [attendees, setAttendees] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0
  });
  const [acquaintanceIds, setAcquaintanceIds] = useState([]);
  const [progress, setProgress] = useState({
    inProgress: false,
    message: "",
  });

  const fetchAttendees = async (page = 1, searchTerm = search) => {
    try {
      const response = await attendeeServices.getAttendees({
        conferenceId: conferenceId.current,
        search: searchTerm,
        page: page,
        limit: 20,
        sort: "-createdAt"
      });
      
      setAttendees(response.data.attendees);
      setPagination(response.pagination);
      setAcquaintanceIds(response.data.acquaintanceIds || []);
    } catch (err) {
      alert(err.message);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchAttendees(newPage, search);
  };

  function exportAttendees() {
    if (progress.inProgress) return;
    setProgress({
      inProgress: true,
      message: "Please wait, exporting attendees!",
    });
    attendeeServices
      .exportAttendees(conferenceId.current)
      .catch((err) => {
        alert(err.message);
      })
      .finally(() => {
        setProgress({
          inProgress: true,
          message: "Please wait, exporting attendees!",
        });
      });
  }

  useEffect(() => {
    fetchAttendees(1, "");
  }, []);

  useEffect(() => {
    setCurrentPage(1);
    fetchAttendees(1, search);
  }, [search]);
  return (
    <Container>
      <Header name={""} />
      <Body>
        <Sidebar />
        <Content>
          <ContentHeader>
            <div className="head-block">
              <h3>User List</h3>
            </div>
            <div className="head-block right">
              <Search
                search={search}
                onChange={(event) => setSearch(event.target.value)}
              />
              <Button
                icon={ExportIcon}
                onClick={exportAttendees}
                btnType={`${false ? "disabled" : ""} exportBtn`}
                name="Export"
              />
            </div>
          </ContentHeader>
          <br />
          <Table>
            <TableHeader>
              <Tr borderWidth={"0px"} background={"transparent"}>
                <Td>S.No.</Td>
                <Td>Name</Td>
                <Td>Email</Td>
                <Td>Company</Td>
                <Td>Team</Td>
                <Td>Registered</Td>
                {/*<Td>Mail Status</Td>*/}
              </Tr>
            </TableHeader>
            <TableBody>
              {attendees.map((attendee, index) => {
                return (
                  <Tr key={index}>
                    <Td>{index + 1}</Td>
                    <Td color="#000000">{attendee.name}</Td>
                    <Td>{attendee.email.replace(/\+.*@/, "@")}</Td>
                    <Td>{attendee.company || "-"}</Td>
                    <Td color={attendee.team ? "#000000" : "#a0a0a0"}>
                      {attendee.team || "Not Assigned"}
                    </Td>
                    <Td color={attendee.registered ? "green" : "#a0a0a0"}>
                      {attendee.registered ? "Registered" : "Pending"}
                    </Td>
                    {/*<Td color={attendee.mailSend ? "green" : "#a0a0a0"}>
                      {attendee.mailSend ? "Sent" : "Pending"}
                </Td>*/}
                  </Tr>
                );
              })}
            </TableBody>
          </Table>
          
          {pagination?.totalPages > 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "20px",
              }}
            >
              <button
                onClick={() => handlePageChange((pagination?.page || 1) - 1)}
                disabled={pagination?.page === 1}
                style={{
                  marginRight: "10px",
                  padding: "5px 10px",
                  cursor: pagination?.page === 1 ? "not-allowed" : "pointer",
                  backgroundColor: pagination?.page === 1 ? "#ccc" : "#007bff",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                }}
              >
                Previous
              </button>

              <span style={{ margin: "0 10px", fontWeight: "bold" }}>
                Page {pagination?.page || 1} of {pagination?.totalPages || 1} ({pagination?.total || 0} total)
              </span>

              <button
                onClick={() => handlePageChange((pagination?.page || 1) + 1)}
                disabled={pagination?.page === pagination?.totalPages}
                style={{
                  marginLeft: "10px",
                  padding: "5px 10px",
                  cursor:
                    pagination?.page === pagination?.totalPages ? "not-allowed" : "pointer",
                  backgroundColor:
                    pagination?.page === pagination?.totalPages ? "#ccc" : "#007bff",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                }}
              >
                Next
              </button>
            </div>
          )}
        </Content>
      </Body>
    </Container>
  );
}

export default Users;